// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"xba-z","narrowOptionButtons":"yba-z","noOptions":"zba-z"};